
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#clip0_638_8052)"}},[_c('path',{attrs:{"d":"M27.796 12.042l-6.84-.984-3.093-6.232c-.516-1.078-2.109-1.125-2.671 0l-3.046 6.232-6.888.984c-1.218.187-1.687 1.687-.796 2.577l4.92 4.826L8.21 26.24c-.187 1.218 1.125 2.155 2.202 1.593l6.139-3.233 6.091 3.233c1.078.562 2.39-.375 2.203-1.593l-1.172-6.795 4.92-4.826c.89-.89.422-2.39-.797-2.577zm-6.56 6.607l1.125 6.466-5.81-3.046-5.857 3.046 1.124-6.466-4.732-4.592 6.513-.937 2.952-5.904 2.905 5.904 6.513.937-4.733 4.592z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_638_8052"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h32v32H0z"}})])])]);
        };
      

        module.exports = {
          
          render: render,
        };
      